import { render } from "./PortfolioTable.vue?vue&type=template&id=415e2964&scoped=true"
import script from "./PortfolioTable.vue?vue&type=script&lang=js"
export * from "./PortfolioTable.vue?vue&type=script&lang=js"

import "./PortfolioTable.vue?vue&type=style&index=0&id=415e2964&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415e2964"]])

export default __exports__